//repeatable code
import React, { useState, memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Upload, Tooltip } from 'antd';
import { Button } from 'appkit-react';
// import { read } from 'xlsx';
import UploadValidator from './uploadDataValidator';
import { API } from '@service';
import alert from '@components/alert';
// import moment from 'moment';
import { formatFinancialUploadhistory } from '@utils/widget';

import ExcelJS from 'exceljs';

const allowedExtensions = ['.xlsx', '.xls'];

export const FinancialUpload = memo(({ updateFinancialData, children }) => {
  const { projectId, projectCompanyInfo } = useSelector(({ common }) => ({
    projectId: common.currentId,
    projectCompanyInfo: common.projectCompanyInfo,
  }));
  const companyInfo = [
    projectCompanyInfo.buyerName,
    projectCompanyInfo.targetName,
  ];
  // console.log(projectCompanyInfo);
  const [showModal, toggleShowModal] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [showUploadStatus, setShowUploadStatus] = useState(false);
  const [message, setMessage] = useState([]);
  const [file, setFile] = useState();
  const [uploadLoading, setUploadloading] = useState(false);
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const [uploadHistory, setUploadHistory] = useState();
  const isInternal = JSON.parse(
    window.localStorage.userInfo || '{}',
  ).isInternal;
  const Badger = ({ isSuccess }) => {
    if (!isSuccess) {
      return <div className="badger error">ERROR</div>;
    }
    return <div className="badger success"> SUCCESS</div>;
  };
  const handleCancel = () => {
    setMessage([]);
    setShowUploadStatus(false);
    setFile(null);
    if (shouldUpdate) {
      updateFinancialData();
    }
    toggleShowModal(!showModal);
    setShouldUpdate(false);
  };
  const handleOk = async () => {
    // toggleShowModal(!showModal);
    if (!file) {
      alert.error('Please click IMPORT to upload file');
      return;
    }
    if (!uploadStatus) {
      alert.error('Please fix errors in the uploaded Excel file.');
      return;
    }
    setUploadloading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', 'report.xlsx');
    const res = await API.uploadExcel(projectId, formData);
    if (res.project?.id) {
      const uploadRes = await API.getUploadHistory(projectId);
      setUploadHistory(uploadRes);
    }
    setUploadloading(false);
    setShouldUpdate(true);
  };
  const downloadExcel = async () => {
    const outName = (projectName) => {
      const H = 'Financial_Data_Downloads';
      const ProjectNameS = projectName.replace(/\s/g, '_');
      const MDY = (([y, m, d]) => `${m}_${d}_${y}`)(
        new Date().toISOString().slice(2, 10).split('-'),
      );
      return [H, ProjectNameS, MDY].join('-');
    };
    await API.exportFinancialsData(projectId).then((response) => {
      console.log('res: ', response, response?.data);
      const res = response?.data ? response?.data : response;
      const file = window.URL.createObjectURL(res);
      console.log('file: ', file);
      const fileName = outName(projectCompanyInfo.projectName);
      // window.location.href = file;
      const a = document.createElement('a');
      a.href = file;
      a.download = `${fileName}.xlsx`;
      a.click();
    });
  };

  // const onImportExcel = (file) => {
  //   message.length = 0;
  //   setShowUploadStatus(false);
  //   const fileTypeValid = allowedExtensions.some((ext) =>
  //     file.name?.endsWith(ext),
  //   );
  //   if (!fileTypeValid) {
  //     setShowUploadStatus(true);
  //     setUploadStatus(false);
  //     setMessage(['Unsupported file type']);
  //     return;
  //   }
  //   const fileReader = new FileReader();
  //   fileReader.onload = (event) => {
  //     const { result } = event.target;
  //     const workbook = read(result, { type: 'binary', cellDates: true });
  //     const dataInput = workbook.Sheets['Data Input'];
  //     const validateResult = new UploadValidator(dataInput, companyInfo);
  //     validateResult.testAll().then((vResult) => {
  //       vResult.forEach((res) => {
  //         if (res === 'Success') {
  //           return;
  //         }
  //         res.forEach((msg) => {
  //           message.push(msg);
  //         });
  //       });
  //       setMessage(message);
  //       setShowUploadStatus(true);
  //       if (message.length === 0) {
  //         setUploadStatus(true);
  //         setFile(file);
  //       } else {
  //         setUploadStatus(false);
  //       }
  //     });
  //   };
  //   fileReader.readAsBinaryString(file);
  //   return false;
  // };

  const onImportExcel = async (file) => {
    message.length = 0;
    setShowUploadStatus(false);

    const fileTypeValid = allowedExtensions.some((ext) =>
      file.name?.endsWith(ext),
    );

    if (!fileTypeValid) {
      setShowUploadStatus(true);
      setUploadStatus(false);
      setMessage(['Unsupported file type']);
      return;
    }

    try {
      const workbook = new ExcelJS.Workbook();
      const arrayBuffer = await file.arrayBuffer();
      await workbook.xlsx.load(arrayBuffer);

      const worksheet = workbook.getWorksheet('Data Input');
      const validateResult = new UploadValidator(worksheet, companyInfo);

      // Rest of your validation logic...
      validateResult.testAll().then((vResult) => {
        vResult.forEach((res) => {
          if (res === 'Success') {
            return;
          }
          res.forEach((msg) => {
            message.push(msg);
          });
        });
        setMessage(message);
        setShowUploadStatus(true);
        if (message.length === 0) {
          setUploadStatus(true);
          setFile(file);
        } else {
          setUploadStatus(false);
        }
      });
    } catch (error) {
      setShowUploadStatus(true);
      setUploadStatus(false);
      setMessage(['Error reading Excel file']);
    }

    return false;
  };

  useEffect(() => {
    if (shouldUpdate) {
      handleCancel();
    }
  }, [shouldUpdate]);

  useEffect(() => {
    (async () => {
      const res = await API.getUploadHistory(projectId);
      setUploadHistory(res);
    })();
  }, [projectId]);
  const instruction = function () {
    return (
      <div>
        Please note that once edits are made, previous versions cannot be
        recovered and data is not auto-refreshed anymore. Uploaded data is only
        applied to current project.
        <br />
        <br />
        1.Click &quot;Export&quot; to download the financial data as an Excel
        file
        <br />
        2.After downloading the data form, edit financial data and save
        <br />
        3.Once edits are complete, return to M&A Gateway and click
        &quot;Import&quot; and upload file from your local drive
        <br />
        4.After importing the data to the system and clicking “Save”, the data
        will be processed at backend
        <br />
        5.Refresh the browser page to reflect the updated data
      </div>
    );
  };
  return projectCompanyInfo?.buyerCraftId?.length < 10 &&
    projectCompanyInfo?.targetCraftId?.length < 10 ? (
    <div className="financial-upload">
      <div className="upload-history">
        {uploadHistory &&
          uploadHistory.length !== 0 &&
          `Upload History: ${formatFinancialUploadhistory(
            new Date(uploadHistory[0]?.uploadedAt),
            uploadHistory[0]?.providedBy,
            true,
          )}`}
      </div>
      {isInternal && (
        <>
          {children}
          <Button
            onClick={() => {
              toggleShowModal(!showModal);
            }}
            style={{ zIndex: 1, whiteSpace: 'nowrap' }}
            className="role-control"
          >
            Edit Financials Data
          </Button>
        </>
      )}
      <Modal
        className="upload-modal"
        title={
          <>
            Edit Financials Data
            <Tooltip
              title={instruction()}
              overlayStyle={{ maxWidth: '31.25rem' }}
            >
              <span className="appkiticon icon-information-fill" />
            </Tooltip>
          </>
        }
        visible={showModal}
        onOk={handleOk}
        onCancel={handleCancel}
        width={880}
        okText="Save"
        cancelText="Cancel"
        confirmLoading={uploadLoading}
        okButtonProps={{
          disabled: !uploadStatus,
        }}
      >
        <div className="left-content">
          <div className="button-area capitalize-title">
            <div>
              <Upload
                beforeUpload={(file) => onImportExcel(file)}
                maxCount={1}
                showUploadList={false}
                accept=".xlsx,.xls"
                className="upload-button"
              >
                <span className="appkiticon icon-upload-fill" />
                import
              </Upload>
            </div>
            <div onClick={downloadExcel}>
              <span className="appkiticon icon-download-fill" />
              export
            </div>
          </div>
          {showUploadStatus ? (
            <div className="info-area">
              <Badger isSuccess={uploadStatus} />
              {message.map((msg, i) => (
                <p key={i}>{msg}</p>
              ))}
            </div>
          ) : null}
        </div>
        <div className="right-content scroll-bar">
          <div className="title">Upload History</div>
          <div className="history-content">
            {uploadHistory &&
              uploadHistory.map((h, i) => (
                <p key={`history-${i}`}>
                  {formatFinancialUploadhistory(
                    new Date(h.uploadedAt),
                    h.providedBy,
                  )}
                </p>
              ))}
            {/* <p>Mar 27, 2021 3:34 PM ET Overwritten by: Jason Park</p>
            <p>Mar 27, 2021 3:34 PM ET Overwritten by: Jason Park</p>
            <p>Mar 27, 2021 3:34 PM ET Overwritten by: Jason Park</p>
            <p>Mar 27, 2021 3:34 PM ET Overwritten by: Jason Park</p> */}
          </div>
        </div>
      </Modal>
    </div>
  ) : null;
});
